<template>
  <div class="schoolCardList-container">
    <div class="schoolCardList-main flex">
      <main-left only-school @treeNodeClick="treeNodeClick" />
      <div class="schoolCardList-right flex_1 div-layout">
        <module-title title="校牌列表">
          <div class="right">
            <el-button
              v-show="treeNode.code"
              type="primary"
              size="medium"
              icon="el-icon-download"
              @click="handlerDownSchoolCard"
            >
              批量导出
            </el-button>
          </div>
        </module-title>
        <div class="schoolCardList-right-contain">
          <p>{{ treeNode.name }}</p>
          <el-form
            ref="schoolCardSearchForm"
            :model="searchForm"
            :inline="true"
            label-position="right"
            label-width="120px"
          >
            <el-form-item label="设备编号：" prop="deviceNo">
              <el-input
                v-model="searchForm.deviceNo"
                name="deviceNo"
                auto-complete="off"
                size="medium"
                placeholder="请输入"
                class="edit-form-input"
                clearable
              />
            </el-form-item>
            <el-form-item label="IMEI号：" prop="imei">
              <el-input
                v-model="searchForm.imei"
                name="imei"
                auto-complete="off"
                size="medium"
                placeholder="请输入"
                class="edit-form-input"
                clearable
              />
            </el-form-item>
            <el-form-item label="绑定状态：" prop="isBind">
              <el-select
                v-model="searchForm.isBind"
                placeholder="选择状态"
                name="isBind"
                size="medium"
                class="edit-form-input"
              >
                <el-option value label="全部" />
                <el-option :value="0" label="未绑定" />
                <el-option :value="1" label="已绑定" />
              </el-select>
            </el-form-item>
            <el-form-item label="学生姓名：" prop="studentName">
              <el-input
                v-model="searchForm.studentName"
                name="studentName"
                auto-complete="off"
                size="medium"
                placeholder="请输入"
                class="edit-form-input"
                clearable
              />
            </el-form-item>
            <el-form-item style="margin-left:50px;">
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="fetchSearchFile"
              >
                查询
              </el-button>
            </el-form-item>
          </el-form>
          <el-table
            v-loading="listLoading"
            :data="schoolCardList"
            fit
            element-loading-text="Loading"
            class="list-table"
            highlight-current-row
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column label="设备编号" prop="deviceNo" align="center" />
            <el-table-column label="校牌型号" prop="deviceModel" align="center" />
            <el-table-column label="IMEI号" prop="imei" align="center" />
            <el-table-column label="绑定学生" prop="studentName" align="center" />
            <el-table-column label="绑定状态" prop="isBind" align="center">
              <template slot-scope="scope">
                {{ scope.row.isBind?'已绑定':'未绑定' }}
              </template>
            </el-table-column>
            <el-table-column label="启用时间" prop="updateDate" align="center" />
            <el-table-column label="操作" align="center" width="310px">
              <template slot-scope="scope">
                <el-button
                  type="success"
                  size="small"
                  icon="el-icon-info"
                  @click=" openStudentCardDetail(scope.row)"
                >
                  详情
                </el-button>
                <el-button
                  v-show="scope.row.isBind"
                  type="warning"
                  size="small"
                  icon="el-icon-warning-outline"
                  @click="removeBindStudent(scope.row)"
                >
                  解除绑定
                </el-button>
                <el-dropdown
                  trigger="click"
                  class="moreBtn"
                  @visible-change="scope.row.more = !scope.row.more"
                  @command="openBindStudent($event,scope.row)"
                >
                  <el-button type="primary" size="small" class="marginleft-10">
                    更多
                    <i
                      :class="[scope.row.more?'el-icon-arrow-up':'el-icon-arrow-down','el-icon--right']"
                    />
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-show="!scope.row.isBind" class="blue" command="a" icon="el-icon-edit">
                      绑定学生
                    </el-dropdown-item>
                    <el-dropdown-item class="blue" command="b" icon="el-icon-edit">
                      更换设备
                    </el-dropdown-item>
                    <el-dropdown-item class="blue" command="c" icon="el-icon-edit">
                      查看日志
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageSchoolCardList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>

    <!-- 绑定学生 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogBindVisible"
      title="绑定学生"
      width="500px"
    >
      <el-form
        ref="bindStudentForm"
        v-loading="bindLoading"
        :model="bindStudentForm"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="年级：" prop="grade">
          <el-select
            v-model="bindStudentForm.grade"
            placeholder="选择年级"
            name="grade"
            size="medium"
            @change="gradeChange"
          >
            <el-option
              v-for="item in gradeList"
              :key="item.grade"
              :label="item.gradeName"
              :value="item.grade"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="班级：" prop="classes">
          <el-select
            v-model="bindStudentForm.classes"
            placeholder="选择班级"
            name="classes"
            size="medium"
            @change="classesChange"
          >
            <el-option
              v-for="item in classesList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :rules="[{ required: true, message: '请选择学生', trigger: 'change' }]"
          label="学生："
          prop="studentCode"
          required
        >
          <el-select
            v-model="bindStudentForm.studentCode"
            placeholder="选择学生"
            name="studentCode"
            size="medium"
          >
            <el-option
              v-for="item in studentList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogBindVisible = false">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="handleBindStudent">
          确定
        </el-button>
      </div>
    </el-dialog>
    <!-- 校牌详情 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogViewVisible"
      title="校牌详情"
      width="700px"
    >
      <p class="archivesTitle">
        基础信息
      </p>
      <div class="manager-info flex">
        <ul>
          <li>
            <label for>设备ID：</label>
            {{ handleCurrentCard.deviceNo }}
          </li>
          <li>
            <label for>所属机构：</label>
            {{ handleCurrentCard.schoolName }}
          </li>
          <li>
            <label for>启用时间：</label>
            {{ handleCurrentCard.updateDate }}
          </li>
        </ul>
        <ul>
          <li>
            <label for>设备类型：</label>
            {{ handleCurrentCard.deviceType }}
          </li>
          <li>
            <label for>IMEI号：</label>
            {{ handleCurrentCard.imei }}
          </li>
        </ul>
      </div>
      <el-divider />
      <p class="archivesTitle">
        参数信息
      </p>
      <div class="manager-info flex">
        <ul>
          <li>
            <label for>设备型号：</label>
            {{ handleCurrentCard.deviceModel }}
          </li>
          <li>
            <label for>嵌入式软件版本号：</label>
            {{ handleCurrentCard.scmVersion }}
          </li>
        </ul>
        <ul>
          <li>
            <label for>系统版本号：</label>
            {{ handleCurrentCard.sysVersion }}
          </li>
        </ul>
      </div>
      <el-divider />
      <p class="archivesTitle">
        绑定信息
      </p>
      <div class="manager-info flex">
        <ul>
          <li>
            <label for>学生姓名：</label>
            {{ handleCurrentCard.studentName }}
          </li>
          <li>
            <label for>所在班级：</label>
            {{ handleCurrentCard.className }}
          </li>
        </ul>
        <ul>
          <li>
            <label for>所在年级：</label>
            {{ handleCurrentCard.gradeName }}
          </li>
          <li>
            <label for>学生学号：</label>
            {{ handleCurrentCard.studentId }}
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="dialogViewVisible = false">
          确定
        </el-button>
      </div>
    </el-dialog>

    <!-- 更换设备 -->
    <el-dialog
      v-if="dialogReplaceVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogReplaceVisible"
      title="更换设备"
      width="500px"
    >
      <el-form
        ref="replaceForm"
        v-loading="replaceloading"
        :model="replaceForm"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="原IMEI号：" prop="imeiOld">
          <span>{{ replaceForm.imeiOld }}</span>
        </el-form-item>
        <el-form-item label="新IMEI号：" prop="imei">
          <el-input
            v-model="replaceForm.imei"
            name="imei"
            auto-complete="off"
            size="medium"
            placeholder="请输入"
            class="replace-form-input"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogReplaceVisible = false">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="handleReplaceSchoolCard">
          确定
        </el-button>
      </div>
    </el-dialog>
    <!-- 查看日志 -->
    <el-dialog
      v-if="dialogViewLogVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogViewLogVisible"
      title="查看日志"
      width="500px"
    >
      <el-form
        ref="viewLogForm"
        v-loading="viewlogloading"
        :rules="viewLogRules"
        :model="viewLogForm"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="选择日期：" prop="date">
          <el-date-picker
            v-model="viewLogForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="选择时间：" prop="time">
          <el-time-picker
            v-model="viewLogForm.time"
            is-range
            value-format="HH:mm"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
            class="replace-form-input"
            @change="chooseThisTime"
          />
        </el-form-item>
        <el-form-item label="选择指令：" prop="command">
          <el-select
            v-model="viewLogForm.command"
            class="recommend-select"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="commandloading"
          >
            <el-option
              v-for="item in commandList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogViewLogVisible = false">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="handleViewLog">
          确定
        </el-button>
      </div>
    </el-dialog>

    <!-- 日志列表 -->
    <el-dialog
      v-if="dialogLogListVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogLogListVisible"
      title="日志列表"
    >
      <el-scrollbar wrap-class="abnormal-table">
        <el-table
          :data="logDataList"
          fit
          highlight-current-row
          width="960px"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="IMEI" prop="imei" align="center" />
          <el-table-column label="command" prop="command" align="center" />
          <el-table-column label="data" prop="data" align="center" />
          <el-table-column label="crt_date" prop="crtDate" align="center" />
          <el-table-column label="type" prop="type" align="center" />
        </el-table>
      </el-scrollbar>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="handleExportLogLiSTExcel">
          导出
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getStageGradeClass, getStudentList } from '@/api/systemMaintenance/devicManage/common';
import {
  getSchoolCardList,
  DownloadSchoolCardDetailUrl,
  getSchoolCardDetail,
  unbindStudentCard,
  bindStudentCard,
  replaceSchoolCard,
  schoolCardLogs,
  exportLogLiSTExcel,
  getLogCommand
} from '@/api/systemMaintenance/devicManage/schoolCardManage';
export default {
  name: 'SchoolCardList',
  data() {
    return {
      bindLoading: false,
      commandloading: false,
      treeNode: {}, // 机构树节点对象
      dialogBindVisible: false, // 绑定学生弹框
      dialogViewVisible: false, //  校牌详情
      dialogReplaceVisible: false,
      dialogViewLogVisible: false,
      dialogLogListVisible: false,
      handleCurrentCard: {}, // 当前点击学生
      searchForm: {
        deviceNo: '',
        imei: '',
        isBind: '',
        studentName: '',
        schoolCode: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        type: 1 // 1校牌2学生卡
      },
      bindStudentForm: {
        grade: '',
        classes: '',
        studentCode: ''
      },
      replaceForm: {
        imeiOld: '',
        imei: '',
        studentCode: ''
      },
      viewLogForm: {
        imei: '',
        date: '',
        time: '',
        toTime: '',
        endTime: '',
        command: ''
      },
      viewLogRules: {
        date: [
          { required: true, message: '日期不能为空', trigger: 'blur' }
        ], time: [
          { required: true, message: '时间不能为空', trigger: 'blur' }
        ]
      },
      commandList: [],
      commandListCopy: [],
      logDataList: [],
      replaceloading: false,
      viewlogloading: false,
      listLoading: false, // 表格刷新loading
      multipleSelection: [], // 表格多选
      schoolCardList: [], //  校牌列表
      gradeList: [], //  年级列表
      classesList: [], //  班级列表
      studentList: [] //  学生列表
    };
  },
  computed: {
    // 是否为机构的普通管理员
    isOrdinaryOrgAdmin() {
      return (
        this.$store.getters.currentOrg.level !== 5 &&
        !this.$store.getters.currentOrg.isSuperAdmin
      );
    }
  },
  methods: {
    // 树点击事件
    treeNodeClick(data) {
      this.treeNode = data;
      this.searchForm.schoolCode = this.treeNode.code;
      this.fetchSchoolCardList();
    },
    // 分页
    pageSchoolCardList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchSchoolCardList();
    },

    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageSize = obj.limit;
      this.fetchSearchFile();
    },
    fetchSearchFile() {
      this.searchForm.pageNum = 1;
      this.fetchSchoolCardList();
    },
    // 表格选择事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 打开绑定学生弹框
    openBindStudent(command, row) {
      if (command === 'a') {
        this.dialogBindVisible = true;
        this.handleCurrentCard = row;
        this.fetchGradeList();
      } else if (command === 'b') {
        this.dialogReplaceVisible = true;
        this.replaceForm = {};
        this.replaceForm.imeiOld = row.imei;
        this.replaceForm.studentCode = row.userCode;
      } else if (command === 'c') {
        this.dialogViewLogVisible = true;
        this.viewLogForm = {};
        this.viewLogForm.imei = row.imei;
        this.fetchLogCommand();
      }
    },
    // 更换设备
    handleReplaceSchoolCard() {
      this.$refs['replaceForm'].validate(valid => {
        if (valid) {
          this.replaceloading = true;
          var op = {
            imei: this.replaceForm.imei,
            studentCode: this.replaceForm.studentCode
          };
          replaceSchoolCard(op).then(res => {
            this.$notify.success({
              title: 'Success',
              message: '更换成功',
              showClose: false,
              duration: 2000
            });
            this.replaceloading = false;
            this.dialogReplaceVisible = false;
            this.fetchSchoolCardList();
          })
            .catch(() => {
              this.replaceloading = false;
            });
        }
      });
    },

    // 时间选择
    chooseThisTime(val) {
      // value-format="HH:mm:ss"//显示时间格式字符串
      if (val && val.length > 0) {
        this.viewLogForm.toTime = val[0];
        this.viewLogForm.endTime = val[1];
      }
    },
    // 指令过滤
    remoteMethod(query) {
      if (query !== '') {
        this.commandloading = true;
        setTimeout(() => {
          this.commandloading = false;
          this.commandList = this.commandListCopy.filter(item => {
            return item.toLowerCase()
              .indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.commandList = [];
      }
    },

    // commandFilter(val) {
    //   this.viewLogForm.command = val;
    //   if (val) {
    //     this.commandList = this.commandListCopy.filter(item => {
    //       if (!!~item.indexOf(val) || !!~item.toUpperCase().indexOf(val.toUpperCase())) {
    //         return true;
    //       }
    //     });
    //   } else {
    //     this.commandList = this.commandListCopy;
    //   }
    // },
    // 查看校牌日志
    handleViewLog() {
      this.$refs['viewLogForm'].validate(valid => {
        if (valid) {
          this.viewlogloading = true;
          var commandGroup = null;
          if (this.viewLogForm.command.length > 0) {
            commandGroup = this.viewLogForm.command.join(',');
          }
          var op = {
            imei: this.viewLogForm.imei,
            toTime: this.viewLogForm.date + ' ' + this.viewLogForm.toTime,
            endTime: this.viewLogForm.date + ' ' + this.viewLogForm.endTime,
            command: commandGroup
          };
          schoolCardLogs(op).then(res => {
            if (res.data && res.data.length > 0) {
              this.logDataList = res.data;
            } else {
              this.logDataList = [];
            }
            this.viewlogloading = false;
            // this.dialogViewLogVisible = false;
            this.dialogLogListVisible = true;
          })
            .catch(() => {
              this.viewlogloading = false;
            });
        }
      });
    },
    // 绑定学生
    handleBindStudent() {
      this.$refs['bindStudentForm'].validate(valid => {
        if (valid) {
          this.bindLoading = true;
          bindStudentCard(
            this.bindStudentForm.studentCode,
            this.handleCurrentCard.imei
          )
            .then(res => {
              this.$notify.success({
                title: 'Success',
                message: '绑定成功',
                showClose: false,
                duration: 2000
              });
              this.bindLoading = false;
              this.dialogBindVisible = false;
              this.fetchSchoolCardList();
            })
            .catch(() => {
              this.bindLoading = false;
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 校牌列表导出
    handlerDownSchoolCard() {
      window.location.href = DownloadSchoolCardDetailUrl(this.treeNode.code, 1);
    },

    // 导出日志列表
    handleExportLogLiSTExcel() {
      if (this.logDataList.length > 0) {
        var op1 = {
          imei: this.viewLogForm.imei,
          toTime: this.viewLogForm.date + ' ' + this.viewLogForm.toTime,
          endTime: this.viewLogForm.date + ' ' + this.viewLogForm.endTime,
          command: this.viewLogForm.command
        };
        window.location.href = exportLogLiSTExcel(op1);
        this.dialogLogListVisible = false;
      } else {
        this.$message.error('日志列表无数据不可导出!');
        this.dialogLogListVisible = false;
      }
    },

    // 获取校牌列表
    fetchLogCommand() {
      getLogCommand().then(res => {
        if (res.data && res.data.length > 0) {
          this.commandListCopy = res.data;
          this.commandList = res.data;
        } else {
          this.commandList = [];
          this.commandListCopy = [];
        }
      });
    },
    // 解除绑定
    removeBindStudent(row) {
      this.$confirm(`确定要解除绑定么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => unbindStudentCard(row.userCode))
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: '解除成功',
            showClose: false,
            duration: 2000
          });
          this.fetchSchoolCardList();
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 获取学生详情
    openStudentCardDetail(row) {
      getSchoolCardDetail(this.treeNode.code, row.imei).then(res => {
        if (res.data) this.handleCurrentCard = res.data;
      });
      this.dialogViewVisible = true;
    },

    // 获取校牌列表
    fetchSchoolCardList() {
      getSchoolCardList(this.searchForm).then(res => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.schoolCardList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.schoolCardList = [];
        }
      });
    },

    // 获取年级
    fetchGradeList() {
      getStageGradeClass(this.searchForm.schoolCode).then(res => {
        if (res.data && res.data.gradeClassVOList) {
          this.gradeList = res.data.gradeClassVOList
            ? res.data.gradeClassVOList
            : [];
        }
      });
    },

    // 年级选择
    gradeChange(val) {
      const gradeObj = this.gradeList.find(x => x.grade === val);
      this.classesList =
        gradeObj && gradeObj.classVOList ? gradeObj.classVOList : [];
      if (gradeObj && gradeObj.classVOList && gradeObj.classVOList.length > 0) {
        this.classesList = gradeObj.classVOList;
        this.bindStudentForm.classes = this.classesList[0].code;
        this.classesChange(this.bindStudentForm.classes);
      } else {
        this.classesList = [];
        this.studentList = [];
        this.bindStudentForm.studentCode = '';
        this.bindStudentForm.classes = '';
      }
    },

    // 班级选择
    classesChange(val) {
      const searchForm = {
        schoolCode: this.treeNode.code,
        grade: this.bindStudentForm.grade,
        classCode: val,
        pageNum: 1,
        pageSize: 100,
        queryType: 1
      };
      getStudentList(searchForm).then(res => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.studentList = res.data.list;
          this.bindStudentForm.studentCode = this.studentList[0].code;
        } else {
          this.studentList = [];
          this.bindStudentForm.studentCode = '';
        }
      });
    }
  }
};
</script>
<style lang="scss">
.abnormal-table{height: 500px;}
</style>
<style lang="scss" scoped>
.schoolCardList-container {
  .schoolCardList-main {
    min-height: 80vh;
    padding-bottom: 20px;
    .schoolCardList-right {
      .schoolCardList-right-contain {
        > p {
          padding-left: 25px;
          font-size: 16px;
          font-weight: bold;
          color: #666666;
          margin-bottom: 20px;
        }
      }
    }
  }
  .edit-form-input {
    width: 8vw;
  }
  .replace-form-input{width: 80%;}
.marginleft-10{
  margin-left: 10px;
}
// 查看详情
  .archivesTitle {
    color: #1890ff;
    font-size: 14px;
    font-weight: bold;
    padding-left: 30px;
    padding-bottom: 20px;
  }
  .manager-info {
    ul {
      margin-left: 60px;
      width: 50%;
      min-width: 220px;
      li {
        margin-bottom: 20px;
      }
    }
  }
}
</style>
